import { download, plus } from "assets/icons";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import { kFormatter2 } from "utils/format";

export default function AppTable({
  children,
  childrenHead,
  tableHead,
  tableHeadLength,
  columnWidth,
  titleA,
  titleB,
  btnTitle,
  btnAction,
  btnWidth,
  tabs,
  startNumber,
  endNumber,
  total,
  nextPage,
  btnDisabled,
  previousPage,
  searchInput = "",
  transactions,
  action,
  param2 = "",
  pagination = true,
  btn = true,
  tableWidth,
  loading,
  tableContent,
}) {
  const router = useNavigate();

  const [param] = useSearchParams();
  const activeTab = param.get("tab");

  const [currentPage, setCurrentPage] = useState(1);
  let currentPageNo = currentPage;
  console.log(currentPageNo);
  const [start, setStart] = useState(1);
  //eslint-disable-next-line
  const [end, setEnd] = useState(50);
  console.log(activeTab);
  return (
    <Table>
      <TableHead>
        <div
          className="table_head"
          style={{
            borderBottom: tabs?.length ? "1px solid #e4e4e4" : "",
          }}
        >
          <div className="title_head">
            <div className="title_a">{titleA}</div>
            <div className="title_b">{titleB}</div>
          </div>
          <div className="table_head_inner">
            {childrenHead}
            {btn && (
              <Button
                disabled={btnDisabled}
                onClick={btnAction}
                style={{
                  width: btnWidth,
                  opacity: (btnDisabled && 0.7) || 1,
                  cursor: (btnDisabled && "not-allowed") || "pointer",
                }}
              >
                <img
                  src={
                    window.location.pathname === "/transactions"
                      ? download
                      : plus
                  }
                  alt=""
                />
                <span>{btnTitle}</span>
              </Button>
            )}
          </div>
        </div>
        {tableContent}
        {tabs?.length && (
          <div className="table_tab">
            {tabs?.map((item) => {
              return (
                <>
                  <TabButton
                    onClick={() => {
                      if (loading) {
                        return;
                      } else {
                        router(item?.route);
                      }
                    }}
                    className={activeTab === item?.param && "active"}
                  >
                    <span>{item.title}</span>
                  </TabButton>
                  &nbsp; &nbsp;
                </>
              );
            })}
          </div>
        )}
      </TableHead>
      <TableBody>
        <TableBodyContent
          className="table_body_head"
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${tableHeadLength}, ${
              columnWidth || "1fr"
            })`,
            width: tableWidth || "fit-content",
          }}
        >
          {tableHead?.map((item) => {
            return <div>{item}</div>;
          })}
        </TableBodyContent>
        <div>{children}</div>
      </TableBody>
      {pagination && (
        <TablePagination>
          <div>
            Showing {start || 0} -{" "}
            {transactions?.results?.length >= 50
              ? end || 0
              : transactions?.results?.length + start - 1 || 0}{" "}
            entries of {kFormatter2(transactions?.count || 0)}
          </div>

          <div className="buttons">
            <button
              onClick={() => {
                if (!transactions?.previous) {
                  console.log("end");
                } else {
                  const prev = async () => {
                    try {
                      const data = await action(
                        `?page=${
                          currentPageNo - 1
                        }&search=${searchInput}&${param2}`
                      );
                      setCurrentPage((current) => current - 1);
                      setStart((current) => current - 50);
                      setEnd((current) => current - 50);
                      console.log(data);
                    } catch (e) {
                      console.log(e);
                    }
                  };

                  prev();
                }
              }}
              style={{
                backgroundColor: !transactions?.previous ? "#fff" : "#F5F5F5",
                border: "1px solid #E0E0E0",
                borderRadius: "6px",
                color: !transactions?.previous ? "#CCCCCC" : "#000",
                cursor: !transactions?.previous ? "default" : "pointer",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              <svg
                style={{
                  transform: "rotate(180deg)",
                  marginRight: "10px",
                }}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.75 12.7744L4.75 12.7744"
                  stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                  stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Prev
            </button>
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={() => {
                if (!transactions?.next) {
                  console.log("end");
                } else {
                  const next = async () => {
                    try {
                      const data = await action(
                        `?page=${
                          currentPageNo + 1
                        }&search=${searchInput}&${param2}`
                      );
                      setCurrentPage((current) => current + 1);
                      setStart((current) => current + 50);
                      setEnd((current) => current + 50);
                      console.log(data);
                    } catch (e) {
                      console.log(e);
                    }
                  };

                  next();
                }
              }}
              style={{
                backgroundColor: !transactions?.next ? "#fff" : "#F5F5F5",
                border: "1px solid #E0E0E0",
                borderRadius: "6px",
                color: !transactions?.next ? "#CCCCCC" : "#000",
                cursor: !transactions?.next ? "default" : "pointer",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
              }}
            >
              Next
              <svg
                style={{
                  marginLeft: "10px",
                }}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.75 12.7744L4.75 12.7744"
                  stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                  stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </TablePagination>
      )}
    </Table>
  );
}

const Table = styled.div`
  background-color: white;
  border-radius: 10px;
`;

const TableHead = styled.div`
  padding: 0 30px;

  .table_tab {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .table_head {
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .table_head_inner {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 20px;
      justify-content: space-between;
    }
  }

  .title_head {
    width: 30%;

    .title_a {
      font-size: 18px;
      color: #9291a5;
    }

    .title_b {
      font-size: 26px;
      width: 100%;
      font-weight: 600;
      margin-top: 10px;
    }
  }
`;

const TableBody = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  overflow-y: scroll;
  height: 65vh;

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
    padding: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 10px;
    background-color: #019edf;
    border-radius: 30px;
  }
  .table_body_head {
    padding: 20px 30px;
    text-transform: uppercase;
    background: #fafafa;
    color: #687182;
  }
`;

const Button = styled.button`
  width: fit-content;
  background-color: #009bff;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 20px 20px;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;

  img {
    margin-right: 10px;
  }
`;

const TabButton = styled.div`
  width: fit-content;
  border: none;
  color: black;
  border-radius: 5px;
  padding: 12px 17px;
  font-size: 12.6px;
  cursor: pointer;

  &.active {
    background-color: #009bff;
    color: white;
  }

  img {
    margin-right: 10px;
  }
`;

export const TableBodyContent = styled.div`
  padding: 10px 0px;
  text-transform: uppercase;
  font-size: 12px;
  .table_body_item:hover {
    background: #f6f6f6;
  }
  .table_body_item:hover > .insName {
    color: #ff993a;
  }
  .insName {
  }
  .insName:hover {
  }
  .table_body_item {
    padding: 14px 30px;
  }

  .table_body_item:nth-child(even) {
    background: #fafafa;
  }
  .table_body_item:nth-child(even):hover {
    background: #f6f6f6;
  }
  .email {
    position: relative;
    cursor: pointer;

    span {
      background-color: #f6f6f6;
      padding: 4px;
      bottom: 20px;
      box-shadow: 2px 2px 2px 0px #d6d6d6;
      left: 0;
      opacity: 0;
      border-radius: 2px;
    }
  }
  .email:hover > span {
    opacity: 1;
  }
`;

const TablePagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  .buttons {
    display: flex;
  }
`;
